import { useTranslation } from 'react-i18next';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export function SearchBar({ value, onChange }: Props) {
  const { t } = useTranslation('games');

  return (
    <label className="search-bar">
      <span className="sr-only">{t('searchPlaceholder')}</span>
      <span aria-hidden="true">⌕</span>
      <input
        type="search"
        value={value}
        placeholder={t('searchPlaceholder')}
        onChange={(event) => onChange(event.target.value)}
        autoComplete="off"
      />
    </label>
  );
}
